<template>
  <v-card class="v-card--wizard" max-width="400">
    <v-tabs ref="tabs" v-model="internalValue" background-color="grey lighten-5" color="white" grow slider-size="70">
      <v-tabs-slider class="mt-1" color="primary" />

      <v-tab
        v-for="(item, i) in items"
        :key="i"
        :ripple="false"
        :disabled="
          !availableSteps.includes(i) || (i == 1 && valueSecondTab == 'disabled') || (i == 0 && valueSecondTab == 'active')
        "
      >
        {{ item }}
      </v-tab>
    </v-tabs>

    <div class="my-6" />

    <v-card-text class="pb-1">
      <v-tabs-items v-model="internalValue">
        <slot />
      </v-tabs-items>
    </v-card-text>

    <v-card-actions class="d-flex flex-column pa-4 pt-0" style="gap: 10px">
      <v-spacer class="flex-shrink-1" />

      <router-link
        v-if="actionLink && (actionLink.showIf || actionLink.showIf === undefined)"
        :to="actionLink.to"
        style="margin-right: 20px"
      >
        <small>{{ actionLink.text }}</small>
      </router-link>

      <v-btn
        v-if="internalValue === 0"
        :disabled="disabledBtnLogar"
        color="primary"
        class="flex-shrink-1"
        min-width="200"
        @click="$emit('click:next')"
      >
        Próximo
      </v-btn>

      <v-btn
        v-if="internalValue === 1"
        :disabled="disabledBtnLogar"
        :loading="loading"
        color="primary"
        class="flex-shrink-1"
        min-width="200"
        @click="$emit('click:next')"
      >
        {{ btnLogarLabel }}
      </v-btn>

      <v-btn
        v-if="internalValue === 0 && showSamlLoginButton"
        style="font-size: 0.7rem !important"
        color="primary"
        min-width="200"
        class="flex-shrink-1 ml-0"
        @click="$emit('click:redirectToSamlLogin')"
      >
        <img class="mr-2" src="@/assets/microsoft.svg" alt="login-background" style="max-width: 25px; height: auto" />
        {{ btnLogarMicrosoftLabel }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  // Mixins
  import Proxyable from 'vuetify/lib/mixins/proxyable';

  export default {
    name: 'BaseLoginMaterialWizard',

    mixins: [Proxyable],

    props: {
      actionLink: {
        type: Object,
        required: false
      },
      availableSteps: {
        type: Array,
        default: () => []
      },
      items: {
        type: Array,
        default: () => []
      },
      disabledBtnLogar: {
        type: Boolean,
        default: false,
        required: false
      },
      loading: {
        type: Boolean,
        default: false
      },
      showSamlLoginButton: {
        type: Boolean,
        default: true
      },
      btnLogarLabel: {
        type: String,
        default: 'Entrar'
      },
      btnLogarMicrosoftLabel: {
        type: String,
        default: 'Entrar com Microsoft'
      }
    },

    data() {
      return {
        valueSecondTab: 'disabled'
      };
    },

    methods: {
      activateSecondTab() {
        this.valueSecondTab = 'active';
        this.internalValue = 1;
      }
    }
  };
</script>

<style lang="sass">
  .v-card--wizard
    overflow: visible

    .v-tabs-bar
      height: 56px
      padding: 0

    .v-tabs-slider-wrapper
      overflow: visible

    .v-tabs-slider
      border-radius: 4px

    .v-tabs-slider-wrapper
      contain: initial
      z-index: 0
</style>
